import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  const isAdmin = !!user?.is_admin;
  const perms = user?.perms || [];
  if (!isAdmin) {
    const hasProdutosPorFilial = perms.includes('produtos_por_filial');
    if (location.pathname.startsWith('/admin/produtos-por-filial')) {
      if (!hasProdutosPorFilial) return <Navigate to="/" replace />;
      return <>{children}</>;
    }
    if (hasProdutosPorFilial) {
      return <Navigate to="/admin/produtos-por-filial" replace />;
    }
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

export const RequirePermission: React.FC<{ permission: string; children: React.ReactNode }> = ({ permission, children }) => {
  const { user } = useAuth();
  const hasPermission = !!user?.is_admin || (user?.perms || []).includes(permission);
  if (!hasPermission) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;


